

import React, { Component } from 'react';
import AuthBanner from './components/AuthBanner';  

import { withTranslation } from 'react-i18next';
import LoginHeader from './components/header';
import LoginFooter from './components/footer';
import Login from './Login';
import CreateUserAcount from './CreateUserAcount';
import ConfirmUserAcount from './ConfirmUserAcount';
import PasswordChange from './PasswordChange';
import PropTypes from "prop-types";

class AuthLayout extends Component {
  render() {
    const { t } = this.props;
    let page = this.props.page;
    let confirmPage = "";

    const authText = [
      t('login.bannerListItem1'),
      t('login.bannerListItem2'),
      t('login.bannerListItem3')
    ];

     const AUTH_COMPONENTS = {
        'login': <Login />,
        'CreateUserAcount': <CreateUserAcount />,
        'ConfirmUserAcount': <ConfirmUserAcount />,
        'PasswordChange': <PasswordChange />,
      };

      if(page=="")
      {
        page = "login"
      }

      if(page=="ConfirmUserAcount")
      {
        page = "login"
        confirmPage = "ConfirmUserAcount"
      }     
 
      return (
      <div className='auth-container'>
        <LoginHeader pageTitle={t('login.authHeaderTitle' + page)} />
        <div className="auth-content">
          <div className="container">
            <div> 
              <div className="row align-items-strech">
                <div className="col-md-6 order-md-1 order-1 custom-height">
                  <AuthBanner
                    title={t('login.bannerTitle')}
                    subtitle={t('login.bannerSubTitle')}
                    authText={authText}
                    buttonTitle={t('login.bannerButton')}
                    buttonLink='/createUserAcount'
                  />
                </div> 
                <div className="col-md-6 order-md-2 order-2 mb-4 mb-md-0 custom-height">
                  <div className="auth-form-area">
                    {AUTH_COMPONENTS[page] || <Login />}
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>

        {confirmPage==="ConfirmUserAcount" && (
          <div> 
            {<ConfirmUserAcount />}                
          </div>
        )}

        <LoginFooter className="login-footer-container" text={t('login.footerText')} />
      </div>
    );
  }
} 

AuthLayout.propTypes = { 
    t: PropTypes.any,
    page: PropTypes.string
  };
 
export default withTranslation()(AuthLayout);

























// import React, { Component } from 'react';
// import AuthBanner from './components/AuthBanner';  

// import { withTranslation } from 'react-i18next';
// import LoginHeader from './components/header';
// import LoginFooter from './components/footer';
// import Login from './Login';
// import CreateUserAcount from './CreateUserAcount';
// import PasswordChange from './PasswordChange';
// import PropTypes from "prop-types";

// class AuthLayout extends Component {
//   render() {
//     const { t } = this.props;
//     const authText = [this.props.t('login.bannerListItem1'),this.props.t('login.bannerListItem2'),this.props.t('login.bannerListItem3')]

//     const AUTH_COMPONENTS = {
//         'login': <Login />,
//         'register': <CreateUserAcount />,
//         'forgot-password': <PasswordChange />,
//       };

//     return (
//         <div className='auth-container'>
//             <LoginHeader pageTitle={t('login.authHeaderTitle'+page)} />
//             <div className="auth-content">
//                 <div className="container">
//                 <div className="row align-items-strech">
//                     <div className="col-md-6 order-md-1 order-2">
//                     <AuthBanner
//                         title={t('login.bannerTitle')}
//                         subtitle={t('login.bannerSubTitle')}
//                         authText={authText}
//                         buttonTitle={t('login.bannerButton')}
//                         buttonLink='/register'
//                     />
//                     </div>
//                     <div className="col-md-6 order-md-2 order-1 mb-4 mb-md-0">
//                         <div className="auth-form-area">
//                             {AUTH_COMPONENTS[page] || <Login />}
//                         </div>
//                     </div>
//                 </div>
//                 </div>
//             </div>
//             <LoginFooter className="login-footer-container" text={t('login.footerText')} />
//         </div>
//     )

//     // return (
//     //   <div className="auth-container">
//     //     <AuthBanner
//     //       title="<strong>Hoş Geldiniz!</strong>"
//     //       subtitle="Hemen giriş yaparak işlemlerinizi yönetin."
//     //       authText={authText}
//     //       buttonTitle="Kayıt Ol"
//     //       buttonLink="/register"
//     //     />
//     //     {/* Diğer içerikler */}
//     //   </div>
//     // );
//   }
// }

// AuthLayout.propTypes = { 
//     t: PropTypes.any,
//   };

// export default withTranslation()(AuthLayout);


















// import { useTranslation } from 'react-i18next';
// import LoginHeader from './components/header';
// import LoginFooter from './components/footer';
// import AuthBanner from './components/AuthBanner';

// import Login from './Login';
// // import Register from './Register';
// // import ForgotPassword from './ForgotPassword';
// import CreateUserAcount from './CreateUserAcount';
// import PasswordChange from './PasswordChange';

// export default function AuthLayout({page}) {
//     const { t } = useTranslation();
//     const authText = [t('login.bannerListItem1'),t('login.bannerListItem2'),t('login.bannerListItem3')]
    
//     const AUTH_COMPONENTS = {
//         'login': <Login />,
//         'register': <CreateUserAcount />,
//         'forgot-password': <PasswordChange />,
//       };

//     return (
//         <div className='auth-container'>
//             <LoginHeader pageTitle={t('login.authHeaderTitle'+page)} />
//             <div className="auth-content">
//                 <div className="container">
//                 <div className="row align-items-strech">
//                     <div className="col-md-6 order-md-1 order-2">
//                     <AuthBanner
//                         title={t('login.bannerTitle')}
//                         subtitle={t('login.bannerSubTitle')}
//                         authText={authText}
//                         buttonTitle={t('login.bannerButton')}
//                         buttonLink='/register'
//                     />
//                     </div>
//                     <div className="col-md-6 order-md-2 order-1 mb-4 mb-md-0">
//                         <div className="auth-form-area">
//                             {AUTH_COMPONENTS[page] || <Login />}
//                         </div>
//                     </div>
//                 </div>
//                 </div>
//             </div>
//             <LoginFooter className="login-footer-container" text={t('login.footerText')} />
//         </div>
//     )
// }
